/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable global-require */
// This ensures that the msw devtool won't be loaded in the production build thanks to tree shaking.
export const MswDevtools =
  process.env.NODE_ENV !== "development"
    ? function MswDevtools() {
        return null
      }
    : require("./MswDevtools").MswDevtools
